import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ChromeReaderModeIcon from '@mui/icons-material/ChromeReaderMode'
import ContactPhoneIcon from '@mui/icons-material/ContactPhone'
import EventNoteIcon from '@mui/icons-material/EventNote'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import MenuIcon from '@mui/icons-material/Menu'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import MovieIcon from '@mui/icons-material/Movie'
import NotificationsIcon from '@mui/icons-material/Notifications'
import PeopleIcon from '@mui/icons-material/People'
import PostAddIcon from '@mui/icons-material/PostAdd'
import TvIcon from '@mui/icons-material/Tv'
import AppBar from '@mui/material/AppBar'
import CssBaseline from '@mui/material/CssBaseline'
import Divider from '@mui/material/Divider'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import useTheme from '@mui/material/styles/useTheme'
import Toolbar from '@mui/material/Toolbar'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'
import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import { authService } from '../../_services'
import Logo from '../../assets/images/logo.png'
import translate from '../../locales/en'
import RoleBasedGuard from '../Guards/RoleBasedGuard'
import Routes from '../Routes/Routes'

const drawerWidth = 190
const useStyles = makeStyles((theme) => ({
  root: { display: 'flex', backgroundColor: '#18191b' },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // backgroundColor: '#242527',
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  // menuButton: { marginRight: 36, color: 'white' },
  hide: { display: 'none' },
  drawer: {
    width: drawerWidth,
    // flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: '#242527',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
    backgroundColor: '#242527',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    overflow: 'hidden',
    minHeight: '100vh',
  },
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.6em',
    },
    '*::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: '#18191b',
      outline: '2px solid slategrey',
    },
  },
}))
const Layout = function () {
  const navigate = useNavigate()
  const location = useLocation()
  const classes = useStyles()
  const theme = useTheme()
  const [open, setOpen] = useState(true)
  const openDrawer = () => setOpen(true)
  const closeDrawer = () => setOpen(false)
  /**
   * Find icons here:
   * https://material-ui.com/components/material-icons/
   */
  const drawerItems = [
    {
      name: 'Home',
      route: '/homes',
      icon: <MenuBookIcon />,
      roles: ['owner', 'admin', 'editor'],
    },
    {
      name: 'Shows',
      route: '/shows',
      icon: <TvIcon />,
      roles: ['owner', 'admin', 'editor'],
    },
    {
      name: 'Videos',
      route: '/videos',
      icon: <MovieIcon />,
      roles: ['owner', 'admin', 'editor'],
    },
    {
      name: 'News',
      route: '/news',
      icon: <ChromeReaderModeIcon />,
      roles: ['owner', 'admin', 'editor'],
    },
    {
      name: 'Schedules',
      route: '/schedules',
      icon: <EventNoteIcon />,
      roles: ['owner', 'admin', 'editor'],
    },
    {
      name: 'Notifications',
      route: '/notifications',
      icon: <NotificationsIcon />,
      roles: ['owner', 'admin', 'editor'],
    },
    {
      name: 'Advertisments',
      route: '/ads',
      icon: <PostAddIcon />,
      roles: ['owner', 'admin', 'editor'],
    },
    {
      name: 'Contact Us',
      route: '/contactus',
      icon: <ContactPhoneIcon />,
      roles: ['owner', 'admin', 'editor'],
    },
    {
      name: 'Donations',
      route: '/donations',
      icon: <AttachMoneyIcon />,
      roles: ['owner'],
    },
    {
      name: 'Users',
      route: '/users',
      icon: <PeopleIcon />,
      roles: ['owner'],
    },
  ].map((item, i) => (
    <RoleBasedGuard key={i} permitedRoles={item.roles}>
      <ListItem
        button
        key={item.name}
        className={
          `/${location.pathname.split('/')[1].toLowerCase()}` ===
          item.route.toLowerCase()
            ? 'activeMenu'
            : ''
        }
        onClick={() => navigate(item.route)}
      >
        <Tooltip title={translate[item.name]} placement="right">
          <ListItemIcon style={{ color: 'white' }}>{item.icon}</ListItemIcon>
        </Tooltip>
        <ListItemText
          primary={translate[item.name]}
          style={{ color: 'white' }}
        />
      </ListItem>
      <Divider key={i} style={{ backgroundColor: 'rgba(255,255,255,0.12)' }} />
    </RoleBasedGuard>
  ))
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            onClick={openDrawer}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          <div className="spread menu">
            <img src={Logo} width="40px" alt="" />
            <Typography variant="h6">
              {translate['CTV Organization Admin Panel']}
            </Typography>
            <div className="actions">
              <Link to="/profile">
                <AccountCircleIcon />
              </Link>
              <Link onClick={() => authService.logout()} to="/">
                <ExitToAppIcon />
              </Link>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={closeDrawer} style={{ color: 'white' }}>
            {theme.direction === 'rtl' ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <List>{drawerItems}</List>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Routes />
      </main>
    </div>
  )
}
export default Layout
